"use strict";
/**
 * Created by Ning Jiang on 8/23/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSprites = void 0;
const GameConfig_1 = require("../gameconfig/GameConfig");
const gsap_1 = require("gsap");
const TimelineSprite_1 = require("../animation/TimelineSprite");
class MultiSprites extends PIXI.Container {
    get sprites() {
        return this._sprites;
    }
    get currentSprite() {
        return this._currentSprite;
    }
    get currentSpriteName() {
        return this._currentSpriteName;
    }
    constructor(config, sourceFPS = GameConfig_1.GameConfig.instance.BROWSER_FPS) {
        super();
        this._sprites = {};
        for (let name in config) {
            this._sprites[name] = new TimelineSprite_1.TimelineSprite(config[name].textures, sourceFPS);
            if (config[name].anchor) {
                this._sprites[name].anchor.set(config[name].anchor[0], config[name].anchor[1]);
            }
            this._sprites[name].visible = false;
            this.addChild(this._sprites[name]);
        }
    }
    // prop is for tweening on the image's prop, such as tweening the x of image.scale.
    playSprite(name, tweenInConfig, tweenOutConfig) {
        const timeline = new gsap_1.TimelineLite();
        if (this._currentSprite && name != this._currentSpriteName) {
            const oldSprite = this._currentSprite;
            if (tweenOutConfig != null) {
                for (let outConfig of tweenOutConfig.vars) {
                    if (outConfig.fromVars != null) {
                        timeline.add(gsap_1.TweenLite.fromTo(outConfig.prop != undefined ? oldSprite[outConfig.prop] : oldSprite, tweenOutConfig.duration, outConfig.fromVars, outConfig.toVars), 0);
                    }
                    else {
                        timeline.add(gsap_1.TweenLite.to(outConfig.prop != undefined ? oldSprite[outConfig.prop] : oldSprite, tweenOutConfig.duration, outConfig.toVars), 0);
                    }
                }
            }
            timeline.add(() => {
                oldSprite.visible = false;
            });
        }
        for (let inConfig of tweenInConfig.vars) {
            if (inConfig.fromVars != null) {
                timeline.add(gsap_1.TweenLite.fromTo(inConfig.prop != undefined ? this._sprites[name][inConfig.prop] : this._sprites[name], tweenInConfig.duration, inConfig.fromVars, inConfig.toVars), 0);
            }
            else {
                timeline.add(gsap_1.TweenLite.to(inConfig.prop != undefined ? this._sprites[name][inConfig.prop] : this._sprites[name], tweenInConfig.duration, inConfig.toVars), 0);
            }
        }
        timeline.add(() => {
            this._sprites[name].visible = true;
            this._currentSpriteName = name;
            this._currentSprite = this._sprites[name];
        }, 0);
        return timeline;
    }
    playSpriteFrames(name, tweenInConfig, tweenOutConfig, frames) {
        const timeline = this.playSprite(name, tweenInConfig, tweenOutConfig);
        timeline.add(this._sprites[name].getAnimation(frames), 0);
        return timeline;
    }
}
exports.MultiSprites = MultiSprites;
//# sourceMappingURL=MultiSprites.js.map